import { render, staticRenderFns } from "./StatusChip.vue?vue&type=template&id=1ed75d09&"
import script from "./StatusChip.vue?vue&type=script&lang=js&"
export * from "./StatusChip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/miryamfv/Proyectos/valet/dz0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ed75d09')) {
      api.createRecord('1ed75d09', component.options)
    } else {
      api.reload('1ed75d09', component.options)
    }
    module.hot.accept("./StatusChip.vue?vue&type=template&id=1ed75d09&", function () {
      api.rerender('1ed75d09', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/StatusChip.vue"
export default component.exports